<template>
  <div class="enterprise-list-page enterprise-list-page--report">
    <!-- Header Card -->
        <PageHeader icon="fas fa-capsules">
      <template #title>
        Laporan Pengeluaran Apotek
      </template>
      <template #subtitle>
        Pantau biaya pembelian dan pengeluaran operasional apotek
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import ReportPageShell from '@/component/reports/ReportPageShell.vue'
import Table from '@/component/reports/PharmacyExpenseReport.vue'
import Card from '@/view/content/Card.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  components: {
    Card,
    ReportPageShell,
    Table
  },

  data(){
    return{
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Laporan" },
      { title: "Laporan Pengeluaran Apotik" },
    ])
  },

}
</script>

<style>
</style>
